import { StyledTheme } from "../theme";

const base = {
  display: "block",
  width: "100%",
  px: 3,
  py: 2,
  appearance: "none",
  fontSize: 1,
  lineHeight: "inherit",
  border: (theme: StyledTheme) => `1px solid ${theme.colors.border}`,
  borderRadius: "default",
  color: "inherit",
  bg: "white",

  ":focus": {
    borderColor: "primary",
    outline: "none",
    boxShadow: (theme: StyledTheme) => `0 0 0 2px ${theme.colors.primary}`,
  },
};

export default {
  base,
};
